var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 30.3337H11.9997C6.11967 30.3337 4.33301 28.547 4.33301 22.667V9.33366C4.33301 3.45366 6.11967 1.66699 11.9997 1.66699H19.9997C25.8797 1.66699 27.6663 3.45366 27.6663 9.33366V22.667C27.6663 28.547 25.8797 30.3337 19.9997 30.3337ZM11.9997 3.66699C7.22634 3.66699 6.33301 4.57366 6.33301 9.33366V22.667C6.33301 27.427 7.22634 28.3337 11.9997 28.3337H19.9997C24.773 28.3337 25.6663 27.427 25.6663 22.667V9.33366C25.6663 4.57366 24.773 3.66699 19.9997 3.66699H11.9997Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6663 8.33301H13.333C12.7863 8.33301 12.333 7.87967 12.333 7.33301C12.333 6.78634 12.7863 6.33301 13.333 6.33301H18.6663C19.213 6.33301 19.6663 6.78634 19.6663 7.33301C19.6663 7.87967 19.213 8.33301 18.6663 8.33301Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 26.48C14.3069 26.48 12.9336 25.1067 12.9336 23.4133C12.9336 21.72 14.3069 20.3467 16.0003 20.3467C17.6936 20.3467 19.0669 21.72 19.0669 23.4133C19.0669 25.1067 17.6936 26.48 16.0003 26.48ZM16.0003 22.3333C15.4136 22.3333 14.9336 22.8133 14.9336 23.4C14.9336 23.9867 15.4136 24.4667 16.0003 24.4667C16.5869 24.4667 17.0669 23.9867 17.0669 23.4C17.0669 22.8133 16.5869 22.3333 16.0003 22.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.16c32de0fb5427962573eb05a717e84a.svg";
export { ForwardRef as ReactComponent };